
export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gray-900 overflow-hidden">
      {/* Background Pattern - Subtle Grid */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)`,
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      {/* Subtle Accent Glow */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-400/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-blue-400/10 rounded-full blur-3xl"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-8 text-center">
        <div className="inline-block mb-6 px-4 py-1.5 bg-white/5 border border-white/10 rounded-full">
          <span className="text-xs font-mono text-blue-300 tracking-wider">AI-DRIVEN WORKFLOW ARCHITECTURE</span>
        </div>

        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
          Turning complexity into clarity across every workflow.
        </h1>

        <p className="text-lg md:text-xl text-gray-300 mb-10 max-w-3xl mx-auto leading-relaxed">
          AI-powered operational systems for service-driven organizations that require precision, efficiency, and scale.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button className="px-8 py-3.5 bg-blue-500 text-white text-sm font-semibold rounded-lg hover:bg-blue-600 transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-blue-500/20">
            Book a Strategy Call
          </button>
          <button className="px-8 py-3.5 bg-transparent text-white text-sm font-semibold rounded-lg border border-white/20 hover:bg-white/5 transition-all cursor-pointer whitespace-nowrap">
            See How It Works
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2">
        <div className="w-6 h-10 border-2 border-white/20 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-2 bg-white/40 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}
